import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import player from 'lottie-web/build/player/lottie_svg';
import { LottieModule } from 'ngx-lottie';
import { AppConfigProvider } from '../app.config';
import { ScrollModule } from '../components/scroll/scroll.module';
import { ShortURLComponent } from './short-url.component';
import { ShortURLGuard } from './short-url.guard';

@NgModule({
  imports: [
    IonicModule,
    TranslateModule,
    LottieModule.forRoot({ player: () => player }),
    ScrollModule,
    RouterModule.forChild([
      {
        path: 's/:code',
        canActivate: [ShortURLGuard],
        component: ShortURLComponent,
      },
    ]),
  ],
  providers: [AppConfigProvider, ShortURLGuard],
  declarations: [ShortURLComponent],
})
export class ShortURLModule {}
